export const JSON_PARSE_ERROR = 'Unexpected token < in JSON at position 0';
